<template>
    <div class="main">

        <!-- PASSO 1 - EDIÇÃO OU CADASTRO DE UM NOVO ALUNO -->
        <div v-if="step == 0">
            <form-aluno :paramId="dados['aluno']['id']" v-on:onSubmitFormAluno="emitAluno"></form-aluno>
        </div>

        <!-- PASSO 2 - CADASTRO DA MATRÍCULA -->
        <div v-if="step == 1">
            <form-matricula :aluno="{id: dados['aluno']['id'], nome: dados['aluno']['nome'], data_nascimento: dados['aluno']['data_nascimento']}" v-on:onSubmitMatricula="emitMatricula" v-on:changeStep="emitChangeStep"></form-matricula>
        </div>

    </div>
</template>
<script>

import formAluno from '@/components/aluno/form/form'
import formMatricula from '@/components/matricula/form/form'

export default {
    data: () => ({
        step: 0,
        dados:{ aluno: { id: '', nome: '', data_nascimento: '' } }
    }),
    mounted(){

        if(this.$route.params.id){

            this.dados['aluno']['id'] = this.$route.params.id;
        }

    },
    methods:{
        emitAluno(aluno){

            this.step = 1;
            this.dados.aluno = aluno;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        emitMatricula(){

            if(this.$route.query.id_pre_matricula) {
                this.$router.push('/admin/pre-matricula-inscritos-novatos');
            } else {
                this.$router.push('/admin/aluno');
            }
           
        },
        emitChangeStep(step){

            this.step = step;
        }
    },
    components:{
        formAluno,
        formMatricula
    }
}
</script>
